export enum ShiftbookType {
	ShiftBook = "1AB743AA-C33C-4DB9-8920-3C8E79B501E3"
}